// extracted by mini-css-extract-plugin
export var content = "HeroCard-module--content--5bd11";
export var holder = "HeroCard-module--holder--68fac";
export var logo = "HeroCard-module--logo--a8a69";
export var title = "HeroCard-module--title--8e4e3";
export var wrapper = "HeroCard-module--wrapper--22cf4";